import * as React from "react";
import styled from "styled-components";
import { Select } from "components/common";
const Container = styled.div``;
const FilterValueSelect = ({ value, onChange, options, placeholder }) => /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
  Select,
  {
    placeholder,
    "aria-label": placeholder,
    menuIsOpen: true,
    clearable: false,
    onChange,
    value,
    options
  }
));
export default FilterValueSelect;
